import React from 'react'
import styled from '@emotion/styled'

import { RadioButton } from '../button'

import { useStateValue } from '../../../hooks'

import { grayLight20, grayLight40, fontSize4XSmall, grayBase } from '../../../constants/principles'
import { FlexRowDiv } from '../Basics'

export default ({ textArray = [], Svgs, valueProp = 'displayName', onClickItem, selectedIndex, id, isError, isDisabled, showIsDefault = false }) => {
  const [isActive, toggleActive] = useStateValue(Svgs.map(() => false))
  return (
    <IconGroup>
      {textArray.map((text, i) => {
        const value = text && (text.displayName || text)
        const SVG = Svgs[i]
        return (
          <StyledButton
            onMouseDown={() =>
              toggleActive(
                isActive
                  .slice(0, i)
                  .concat([true])
                  .concat(isActive.slice(i + 1))
              )
            }
            onMouseOver={() => {
              toggleActive([false, false])
            }}
            onMouseUp={() => toggleActive([false, false])}
            onMouseOut={() => {
              toggleActive([false, false])
            }}
            onClick={() => onClickItem(i)}
            id={`${id || value}-${i}`}
            data-testid={`btn-${id?.toString().replace(/[^A-Z0-9]/ig, "-").toLowerCase()|| value?.toString().replace(/[^A-Z0-9]/ig, "-").toLowerCase()}-${i}`}
            isSelected={selectedIndex === i}
            key={i}
            disabled={isDisabled}
            isError={isError}>
            {SVG && <SVG color={selectedIndex === i || isActive[i] ? 'white' : 'black'} id={value} alt="icon" />}
            <FullWidthFlex>
              <StyledDiv id={value}>
                {value}
                {showIsDefault && text.isDefault && <MostCommonDiv isSelected={selectedIndex === i || isActive[i]}>(Most Common)</MostCommonDiv>}
              </StyledDiv>
            </FullWidthFlex>
          </StyledButton>
        )
      })}
    </IconGroup>
  )
}
const FullWidthFlex = styled(FlexRowDiv)`
  padding-top: 4px;
  width: 100%;
`

const StyledButton = styled(RadioButton)`
  width: 110px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  padding: 10px 2px;
  &:disabled {
    border-color: ${grayLight40};
    background: ${grayLight40};
    color: ${grayLight20};

    cursor: not-allowed;
  }
`
const StyledDiv = styled.div`
  padding-right: 8px;
  padding-left: 8px;
  line-height: 1;
`
const MostCommonDiv = styled.div`
  font-size: ${fontSize4XSmall};
  color: ${p => (p.isSelected ? `white` : grayBase)};
`
export const IconGroup = styled.div`
  align-items: stretch;
  display: flex;
  justify-content: center;
  margin: 8px;
`
